import { memo } from 'react';
import { cn } from '@divlab/divanui';

import useTranslation from '@Queries/useTranslation';
import styles from './Stripe.module.css';

import type { FC, HTMLAttributes } from 'react';

interface StripeProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
}

const Stripe: FC<StripeProps> = (props) => {
  const { className, ...restProps } = props;
  const { t } = useTranslation();

  const stripeArray = Array.from({ length: 16 }, (v, ind) => ind + 1);

  return (
    <div {...restProps} className={cn(styles.tickerWrap, className)}>
      <div className={styles.ticker}>
        <span>
          {stripeArray.map((i) => {
            return (
              <span key={i} className={styles.stripeText}>
                {t('express-design')}
              </span>
            );
          })}
        </span>
      </div>
    </div>
  );
};

export default memo(Stripe);
